export const environment = {
  production: true,
  serverUrl: window.env.serverUrl || "default",
  apiUrl: window.env.apiUrl || "default",
  version: window.env.bcteVersion || "developer"
};
